import _kebabCase from 'lodash/kebabCase'
export default function addClassesToModelHeaders(headers) {
  headers = headers.map((header) => {
    let classes = `order-header-${_kebabCase(header.value)}`
    let cellClass = `order-cell-${_kebabCase(header.value)}`
    if (header.sticky) {
      classes += ' header-sticky'
      cellClass += ' cell-sticky'
    }
    return {
      ...header,
      class: classes,
      cellClass,
    }
  })
  return headers
}
